import React from 'react'

import { I18n } from './model'

export const useLanguage = () => {
  const context = React.useContext(I18n)

  if (context == null) {
    throw '[i18n]: useLanguage should nest in LanguageProvider'
  }

  return context
}
